module.exports = __webpack_public_path__ + "img/revexpo_1390.2013c200.jpg";